import {QuestionIcon} from '@primer/octicons-react'
import type {ReactNode} from 'react'
import {ResolvedPromptDisplay} from './ResolvedPromptDisplay'

export interface ResolvedAskUserProps {
  /** The question that was asked */
  question: string
  /** Short title for the card header (defaults to question) */
  title?: string
  /** Whether this prompt was skipped/aborted */
  isSkipped?: boolean
  /** Whether this prompt was aborted by the user (e.g. Escape key) */
  isAborted?: boolean
  /** The answer that was given */
  resolvedAnswer?: string
}

/** Resolved ask_user prompt shown in the session timeline */
export function ResolvedAskUser({
  question,
  title,
  isSkipped = false,
  isAborted = false,
  resolvedAnswer,
}: ResolvedAskUserProps) {
  const cardTitle = title ?? question

  let displayAnswer: ReactNode | undefined
  if (isSkipped || isAborted) {
    displayAnswer = undefined
  } else if (resolvedAnswer === 'Declined') {
    displayAnswer = 'Declined'
  } else if (resolvedAnswer) {
    // Preserve newlines so multi-question elicitation answers (joined with `\n`)
    // don't collapse onto a single row.
    displayAnswer = <span style={{whiteSpace: 'pre-wrap'}}>{resolvedAnswer}</span>
  }

  const subtitle = isAborted ? 'Aborted by user' : isSkipped ? 'Skipped' : undefined

  return (
    <ResolvedPromptDisplay icon={<QuestionIcon size={16} />} title={cardTitle} subtitle={subtitle}>
      {displayAnswer}
    </ResolvedPromptDisplay>
  )
}
